import { Link } from 'react-router-dom'

import { SymbiosisButton } from '~/components/SymbiosisButton'
import { useVESISParams } from '~/hooks/useVESISParams'

import LogoIcon from './assets/logo.svg'

import styles from './NoActiveLock.pcss'
import PageDescription from '~/components/PageDescription'
import React from 'react'

export function NoActiveLock() {
	const { config } = useVESISParams()

	return (
		<>
			<PageDescription>
				{`SIS -> veSIS`}
				<br />
				Staking your SIS tokens and becoming a veSIS holder unlocks
				exclusive benefits, ensuring you get the most out of the
				Symbiosis ecosystem. veSIS is not just holding a digital asset;
				it's an investment into a thriving ecosystem that rewards your
				faith and dedication.{' '}
				<a
					href="https://medium.com/symbiosis-fi/empowering-sis-vesis-holders-special-perks-324dbf92ae6f"
					className={styles.link}
					target="_blank"
					rel="noreferrer noopener"
				>
					A 4-stage plan to provide more benefits and perks to veSIS
					holders.
				</a>
			</PageDescription>
			<div className={styles.container}>
				<div className={styles.content}>
					<div className={styles.text}>
						YOU HAVE NO ACTIVE LOCKS CREATE YOUR FIRST LOCK
					</div>
					<LogoIcon />
				</div>
				<SymbiosisButton as={Link} to={`/vesis/${config.slug}/create`}>
					Create Lock
				</SymbiosisButton>
			</div>
		</>
	)
}
